import { render } from "./upload-arquivos.vue?vue&type=template&id=1bf68b33"
import script from "./upload-arquivos.vue?vue&type=script&lang=js"
export * from "./upload-arquivos.vue?vue&type=script&lang=js"

import "./upload-arquivos.vue?vue&type=style&index=0&id=1bf68b33&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__